import React, { Component } from "react";
import MaterialTable from "material-table";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Input,
  Label,
  Form,
  Collapse,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import history from "../../history";
import "react-toastify/dist/ReactToastify.css";
import CartTitle from "../CartTitle";
import FilterCard from "../filterCard";
import Loader from "../Loader";
import get from "lodash/get";
import BranchDetail from "../BranchDetail";
import { fetchQueryParams } from "../../utils/comman";
import CustomButton from "../CustomButton";
import InputText from "../InputText";
import CustomDatepicker from "../CustomDatepicker";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sessionActions from "../../redux/partners/actions";
import PartnerDetails from "../PartnerDetails";
import PartnerPersonalForm from "../PartnerPersonalForm";
import * as uploadActions from "../../redux/uploadImage/action";
import * as globalAction from "../../redux/Global/actions";
import * as userActions from "../../redux/user/actions";

const _ = { get };

class PartnersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleActive: true,
      page: 0,
      pageSize: 10,
      countryCode: "",
      country: "",
      status: "PENDING",
      prevStatus: "PENDING",
      count: 100,
      selectedId: "",
      selectedEmail: "",
      toggleModal: false,
      toggleAddModal: false,
      // countryList: [],
      // parsedCountry: "",
      email: "",
      phone: "",
      toggleRejectModal: false,
      rejectionReason: "",
    };
  }

  componentDidMount() {
    let obj = {
      page: this.state.page,
      limit: this.state.count,
      status: this.state.status,
      country: this.state.countryCode,
      email: this.state.email,
      phone: this.state.phone,
    };
    this.handleFetchPartnersList(obj);
    // this.handleSetCountries();
    this.handleFetchJson();
    this.handleFetchTourCountriesJson();
    this.handleCountryMobileCodeFetch();
    this.handleFetchMotorcycle("uk");
    this.handlePartnerRating();
  }

  componentDidUpdate(prevProps, prevState) {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (prevProps.partnersList.length !== this.props.partnersList.length) {
      let state = this.state;

      state.page = Math.ceil(this.props.partnersList.length / this.state.count);
      this.setState({ ...state });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.prevStatus !== this.state.status) {
      let obj = {
        page: this.state.page,
        limit: this.state.count,
        status: this.state.status,
        country: this.state.countryCode,
        email: this.state.email,
        phone: this.state.phone,
      };
      let state = this.state;
      state.prevStatus = state.status;
      this.setState({ ...state });
      this.handleFetchPartnersList(obj);
    }
  }
  handleFetchPartnersList = (payload) => {
    this.props.actions.fetchPartnersList(payload);
  };

  handleFetchState = (data) => {
    this.props.actions.fetchState(data);
  };

  handleFetchCity = (data) => {
    this.props.actions.fetchCity(data);
  };

  handlePartnerRating = () => {
    this.props.actions.PartnerRanking();
  };

  handleFetchPartnerDetails = (data) => {
    this.props.actions.fetchPartnersDetails(data);
  };

  clearingPreviousReducer = (data) => {
    this.props.actions.clearingPreviousReducer(data);
  };

  handleFetchJson = () => {
    this.props.global.fetchingRegionJson();
  };

  handleFetchTourCountriesJson = () => {
    this.props.global.fetchingCountriesJson();
  };
  handleCountryMobileCodeFetch = () => {
    this.props.user.fetchUserCountryMobileCode();
  };

  handleFetchMotorcycle = (data) => {
    this.props.user.fetchMotorCylce(data);
  };

  // handleSetCountries = () => {
  //   let countries = JSON.parse(localStorage.getItem("countries"));
  //   let accessibleCountries = JSON.parse(
  //     localStorage.getItem("accessCountries")
  //   );
  //   if (accessibleCountries && accessibleCountries[0] === "*") {
  //     let state = this.state;
  //     state.countryList = countries;
  //     console.log("===Star state===", this.state.countryList);
  //     this.setState({ ...state });
  //   }
  //   if (accessibleCountries && accessibleCountries[0] !== "*") {
  //     let state = this.state;
  //     let newCountry = countries.filter((data) =>
  //       accessibleCountries.includes(data.locality.country)
  //     );
  //     state.countryList = newCountry;
  //     let code = newCountry[0].locality.country;
  //     let countryName = newCountry[0].country;

  //     state.countryCode = code;
  //     state.country = countryName;
  //     console.log("===Non Star state===", this.state.countryList);
  //     this.setState({ ...state });
  //   }
  // };

  handleCreatePartner = (data) => {
    this.props.actions.partnerForm(data, this.handleCallBack);
  };
  handleCallBack = () => {
    this.handleAddToggleModel();
    let obj = {
      page: this.state.page,
      limit: this.state.count,
      status: this.state.status,
      country: this.state.countryCode,
      email: this.state.email,
      phone: this.state.phone,
    };
    this.handleFetchPartnersList(obj);
  };

  handleOnPageChange = (e, page) => {
    let totalPages = this.props.partnersList.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.partnersList.length !== 0 &&
      this.props.partnersList.length < this.props.partnersListCount;

    if (fetchNextData === true) {
      let obj = {
        page: this.state.page,
        limit: this.state.count,
        status: this.state.status,
        country: this.state.countryCode,
        email: this.state.email,
        phone: this.state.phone,
      };
      this.handleFetchPartnersList(obj);
    }
  };

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleFilterChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleChangeStatus = (e) => {
    let state = this.state;
    state.status = e.target.value;
    this.setState({ ...state });
  };

  handleToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleAddToggleModel = (e) => {
    let newState = { ...this.state };
    newState.toggleAddModal = !newState.toggleAddModal;
    this.setState({ ...newState });
  };

  handleRowData = (rowData) => {
    let newState = { ...this.state };
    newState.selectedId = rowData._id;
    newState.selectedEmail = rowData.email
    newState.toggleModal = !newState.toggleModal;
    this.setState({ ...newState });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "") {
      state.country = e.target.value;
      let parsedValue = this.props.tourCountriesJson.filter((item) => {
        if (item.country === e.target.value) {
          return item.locality.country;
        }
      })[0].locality.country;
      state.countryCode = parsedValue;
    } else {
      state.country = "";
      state.countryCode = "";
    }
    this.setState({ ...state });
  };

  handleSubmitFilter = (e) => {
    e.preventDefault();

    let state = this.state;
    let data = {
      page: 0,
      country: state.country,
      state: state.state,
      city: state.city,
      email: state.email.toLowerCase().trim(),
      phone: state.phone.trim(),
      limit: state.count,
      status: state.status,
    };
    if (
      state.countryCode !== "" ||
      state.state !== "" ||
      state.city !== "" ||
      state.email !== "" ||
      state.phone !== "" ||
      state.status !== ""
    ) {
      this.handleFetchPartnersList(data);
      this.clearingPreviousReducer();
    }
  };

  handleClearFilter = () => {
    let state = this.state;
    state.page = 0;
    state.country = "";
    state.countryCode = "";
    state.state = "";
    state.city = "";
    state.count = 100;
    state.parsedCountry = "";
    state.email = "";
    state.phone = "";
    state.status = "PENDING";
    this.setState({ ...state });
    let data = {
      page: 0,
      country: "",
      email: "",
      phone: "",
      limit: 100,
      status: "PENDING",
    };
    this.handleFetchPartnersList(data);
    this.clearingPreviousReducer();
  };

  handleRejectModal = () => {
    let state = this.state;
    state.toggleRejectModal = !state.toggleRejectModal;
    state.rejectionReason = "";
    this.setState({ ...state });
  };

  handleOnChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleDelete = (e) => {
    let state = this.state;
    let obj = {
      partnerId: state.selectedId,
      status: "DELETED",
      rejectionReason: state.rejectionReason,
      email: state.selectedEmail,
    };
    this.props.actions.deletePartnerInfo(obj, this.handleDeleteCallBack);
  };

  handleDeleteCallBack = () => {
    this.handleRejectModal();
    this.handleToggleModel();
    let obj = {
      page: this.state.page,
      limit: this.state.count,
      status: this.state.status,
      country: this.state.countryCode,
      email: this.state.email,
      phone: this.state.phone,
    };
    let state = { ...this.state };
    state.rejectionReason = "";
    this.setState(state);
    this.handleFetchPartnersList(obj);
  };

  render() {
    let { elements } = this.props;
    return (
      <React.Fragment>
        <div className="hideSearch custom-m-table mt-4">
          {this.props.fetchingPartnersList !== false ? <Loader /> : null}
          <Form onSubmit={this.handleSubmitFilter}>
            <Row>
              <Col sm={12}>
                <CartTitle
                  title={_.get(
                    elements,
                    "euToursElement.partnerListElement.partnerHeadingElement",
                    "Partners"
                  )}
                  iconClass={"hideexcel"}
                  ButtonRight={_.get(
                    elements,
                    "euToursElement.partnerListElement.addNewElement",
                    "Add New"
                  )}
                  Name={_.get(
                    elements,
                    "euToursElement.partnerListElement.filterButtonElement",
                    "Filter"
                  )}
                  handleToggle={() => this.handleToggle()}
                  handleAddToggle={() => this.handleAddToggleModel()}
                  textTitle={_.get(
                    elements,
                    "euToursElement.partnerListElement.totalCountElement",
                    "Total Count - "
                  )}
                  preRegisteredUserCount={this.props.partnersListCount}
                />
              </Col>
              <Col sm={12}>
                <Collapse isOpen={this.state.toggleActive}>
                  <Card className="mb-3">
                    <CardBody>
                      <Row>
                        <Col xl={4} lg={4} md={6} sm={6}>
                          <label class="inputLabel">
                            {_.get(
                              elements,
                              "euToursElement.partnerListElement.countryElement",
                              "Country"
                            )}
                          </label>
                          <FormGroup className=" confirmRiderSelect select_options">
                            {this.props.accessibleCountries &&
                            this.props.accessibleCountries.length === 1 &&
                            this.props.accessibleCountries[0] !== "*" ? (
                              <>
                                <Input
                                  type="select"
                                  name="city"
                                  className="w-100 customeSelectBtn"
                                  onChange={this.handleCountryChange}
                                  value={this.state.country}
                                >
                                  <option value="">
                                    {_.get(
                                      elements,
                                      "euToursElement.partnerListElement.selectCountryElementt",
                                      "Select Country"
                                    )}
                                  </option>
                                  {this.props.tourCountriesJson &&
                                    this.props.tourCountriesJson.length > 0 &&
                                    this.props.tourCountriesJson.map(
                                      (item, index) => (
                                        <option
                                          key={index}
                                          value={item.country}
                                        >
                                          {item.country}
                                        </option>
                                      )
                                    )}
                                </Input>
                              </>
                            ) : (
                              <Input
                                type="select"
                                name="city"
                                className="w-100 customeSelectBtn"
                                onChange={this.handleCountryChange}
                                value={this.state.country}
                              >
                                <option value="">
                                  {_.get(
                                    elements,
                                    "euToursElement.partnerListElement.selectCountryElementt",
                                    "Select Country"
                                  )}
                                </option>
                                {this.props.tourCountriesJson &&
                                  this.props.tourCountriesJson.length > 0 &&
                                  this.props.tourCountriesJson
                                    .sort((a, b) =>
                                      a.name > b.name
                                        ? 1
                                        : b.name > a.name
                                        ? -1
                                        : 0
                                    )
                                    .map((item, index) => (
                                      <option key={index} value={item.country}>
                                        {item.country}
                                      </option>
                                    ))}
                              </Input>
                            )}
                          </FormGroup>
                        </Col>
                        {/* <Col xl={4} lg={4} md={6} sm={6}>
                          <FormGroup className=" confirmRiderSelect select_options">
                            <Input
                              type="select"
                              name="branchType"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleStateChange}
                              value={this.state.state}
                            >
                              <option>
                                {this.state.state !== ""
                                  ? this.state.state
                                  : _.get(
                                      elements,
                                      "dealersListingFilterElements.selectStateLabel",
                                      "Select State"
                                    )}
                              </option>
                              {this.props &&
                                this.props.states &&
                                this.props.states
                                  .sort((a, b) =>
                                    a.name > b.name
                                      ? 1
                                      : b.name > a.name
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={JSON.stringify(item)}
                                    >
                                      {item}
                                    </option>
                                  ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6}>
                          <FormGroup className=" confirmRiderSelect select_options">
                            <Input
                              type="select"
                              name="branchType"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleCityChange}
                              value={this.state.city}
                            >
                              <option>
                                {this.state.city !== ""
                                  ? this.state.city
                                  : _.get(
                                      elements,
                                      "dealersListingFilterElements.selectCityLabel",
                                      "Select City"
                                    )}
                              </option>
                              {this.props &&
                                this.props.cities &&
                                this.props.cities
                                  .sort((a, b) =>
                                    a.name > b.name
                                      ? 1
                                      : b.name > a.name
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={JSON.stringify(item)}
                                    >
                                      {item.cityName}
                                    </option>
                                  ))}
                            </Input>
                          </FormGroup>
                        </Col> */}
                        <Col xl={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "euToursElement.partnerListElement.emailElement",
                              "Email"
                            )}
                            inputType={"email"}
                            inputName={"email"}
                            InputClass={"inputText"}
                            customValue={this.state.email}
                            inputPlaceholder={_.get(
                              elements,
                              "euToursElement.partnerListElement.emailPlaceholder",
                              "Email"
                            )}
                            customOnChange={(e) => this.handleFilterChange(e)}
                          />
                        </Col>
                        <Col xl={4}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "euToursElement.partnerListElement.phoneElement",
                              "Phone"
                            )}
                            inputType={"number"}
                            inputName={"phone"}
                            InputClass={"inputText"}
                            customValue={this.state.phone}
                            inputPlaceholder={_.get(
                              elements,
                              "euToursElement.partnerListElement.phonePlaceholder",
                              "Phone"
                            )}
                            customOnChange={(e) => this.handleFilterChange(e)}
                          />
                        </Col>
                      </Row>

                      <Row>
                        <Col
                          lg={12}
                          className="d-flex align-items-center justify-content-end"
                        >
                          <div className="d-flex mt-3">
                            <CustomButton
                              customType={"submit"}
                              name={_.get(
                                elements,
                                "euToursElement.partnerListElement.searchButtonElement",
                                "Search"
                              )}
                              customClass={
                                "btn-outline-dark ml-2 bg-none btnthemeColor"
                              }
                            />
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "euToursElement.partnerListElement.clearFilterButtonElement",
                                "Clear Filter"
                              )}
                              customClass={
                                "btn-outline-dark ml-2 bg-none btnthemeColor"
                              }
                              customClick={this.handleClearFilter}
                            />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Collapse>
              </Col>
              <Col sm={12}>
                <Card className="mb-3">
                  <CardBody>
                    <Row>
                      <Col xl={3} lg={3} md={6} sm={6}>
                        <Label className="inputLabel">
                          {_.get(
                            elements,
                            "euToursElement.partnerListElement.statusTitleElement",
                            "Status"
                          )}
                        </Label>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="status"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleChangeStatus}
                            value={this.state.status}
                          >
                            <option value={"PENDING"}>
                              {_.get(
                                elements,
                                "euToursElement.partnerListElement.pendingElement",
                                "Pending"
                              )}
                            </option>
                            <option value={"APPROVED"}>
                              {_.get(
                                elements,
                                "euToursElement.partnerListElement.approvedElement",
                                "Approved"
                              )}
                            </option>
                            <option value={"REJECTED"}>
                              {_.get(
                                elements,
                                "euToursElement.partnerListElement.rejectedElement",
                                "Rejected"
                              )}
                            </option>
                            <option value={"MODIFIED"}>
                              {_.get(
                                elements,
                                "euToursElement.partnerListElement.modifiedElement",
                                "Modified"
                              )}
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
          <Row>
            <Col sm="12">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "euToursElement.partnerListElement.partnerTitlelement",
                      "Partner"
                    ),
                    field: "name",
                  },
                  {
                    title: _.get(
                      elements,
                      "euToursElement.partnerListElement.emailTitleElement",
                      "Email"
                    ),
                    field: "email",
                  },

                  {
                    title: _.get(
                      elements,
                      "euToursElement.partnerListElement.phoneTitleElement",
                      "Phone"
                    ),
                    field: "mobile",
                    render: (rowData) => {
                      return `${rowData.mobile.callingCode} ${rowData.mobile.number}`;
                    },
                  },
                  {
                    title: _.get(
                      elements,
                      "euToursElement.partnerListElement.countryTitleElement",
                      "Country"
                    ),
                    field: "country",
                  },
                  {
                    title: _.get(
                      elements,
                      "euToursElement.partnerListElement.statusTitleElement",
                      "Status"
                    ),
                    field: "moderationStatus",
                  },
                ]}
                data={this.props.partnersList}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: this.state.pageSize,
                  paginationType: "stepped",
                  initialPage: 1,
                  showFirstLastPageButtons: false,
                }}
                actions={[
                  {
                    icon: "assignment_ind",
                    tooltip: "Detail Page",
                    onClick: (event, rowData) => this.handleRowData(rowData),
                  },
                ]}
                onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "euToursElement.partnerListElement.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "euToursElement.euCustomMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "euToursElement.euCustomMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "euToursElement.euCustomMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                  header: {
                    actions: _.get(
                      elements,
                      "euToursElement.partnerListElement.actionsElement",
                      "Actions"
                    ),
                  },
                }}
              />
            </Col>
          </Row>
          <Modal
            isOpen={this.state.toggleModal}
            toggle={this.handleToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <PartnerDetails
                selectedId={this.state.selectedId}
                partnerDetailsData={this.props.partnerDetailsData}
                handleFetchPartnerDetails={this.handleFetchPartnerDetails}
                handleToggleModel={this.handleToggleModel}
                handleRejectModal={this.handleRejectModal}
                elements={this.props.elements}
                component={"List"}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={this.state.toggleAddModal}
            toggle={this.handleAddToggleModel}
            backdrop={true}
            centered={true}
            size="xl"
            className="modal_main"
          >
            <ModalBody>
              <PartnerPersonalForm
                handleToggleModel={this.handleAddToggleModel}
                countryList={this.props.tourCountriesJson}
                countryMobileCode={this.props.countryMobileCode}
                motorCycle={this.props.motorCycle}
                handleCreatePartner={this.handleCreatePartner}
                usertype={this.props.usertype}
                editInfo={false}
                fetchList={this.handleFetchPartnersList}
                uploadUrl={this.props.uploadImage.uploadUrl}
                clearingPreviousReducer={
                  this.props.uploadImage.clearingPreviousReducer
                }
                uploadGalleryUrl={this.props.uploadImage.uploadGalleryUrl}
                uploadVideoUrl={this.props.uploadImage.uploadVideoUrl}
                regionJson={this.props.regionJson}
                elements={this.props.elements}
                partnerRankingNumber={this.props.partnerRankingNumber}
                formType={"create"}
              />
            </ModalBody>
          </Modal>
          <Modal
            isOpen={this.state.toggleRejectModal}
            backdrop={true}
            centered={true}
          >
            <ModalHeader toggle={this.handleRejectModal}>
              {_.get(
                elements,
                "euToursElement.partnerListElement.rejectionModelLabel",
                "Rejection Reason"
              )}
            </ModalHeader>
            <ModalBody>
              <InputText
                inputType={"textarea"}
                inputName={"rejectionReason"}
                customValue={this.state.rejectionReason}
                customOnChange={(e) => this.handleOnChange(e)}
              />
            </ModalBody>
            <ModalFooter>
              <CustomButton
                customType={"submit"}
                name={_.get(
                  elements,
                  "euToursElement.partnerListElement.rejectModelButtonElement",
                  "Reject"
                )}
                customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                customClick={(e) => this.handleDelete(e)}
              />
            </ModalFooter>
          </Modal>
        </div>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
    uploadImage: bindActionCreators(uploadActions, dispatch),
    global: bindActionCreators(globalAction, dispatch),
    user: bindActionCreators(userActions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    fetchingPartnersList: state.Partner.fetchingPartnersList,
    partnersList: state.Partner.partnersList,
    partnersListCount: state.Partner.partnersListCount,
    tourCountriesJson: state.Global.tourCountriesJson,
    accessibleCountries: state.Auth.userProfile.accessibleCountries,
    stateStatus: state.Partner.stateStatus,
    states: state.Partner.states,
    cityStatus: state.Partner.cityStatus,
    cities: state.Partner.cities,
    partnerDetailsStatus: state.Partner.partnerDetailsStatus,
    partnerDetailsData: state.Partner.partnerDetailsData,
    usertype: state.Auth.usertype,
    regionJson: state.Global.regionJson,
    countryMobileCode: state.User.countryMobileCode,
    motorCycle: state.User.motorCycle,
    elements: state.Elements.elements,
    partnerRankingNumber: state.Partner.partnerRankingNumber,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PartnersList)
);
